/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PackageVersion = {
  /**
   * The creation date of the package version
   */
  createdAt: Date;
  /**
   * The ID of the deployment that the version belongs to
   */
  deploymentId: string;
  /**
   * The ID of the package version
   */
  id: string;
  /**
   * The ID of the package that the version belongs to
   */
  packageId: string;
  /**
   * The semantic version value
   */
  semver: string;
  /**
   * The visibility of the package version
   */
  visibility: string;
};

/** @internal */
export const PackageVersion$inboundSchema: z.ZodMiniType<
  PackageVersion,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    deployment_id: z.string(),
    id: z.string(),
    package_id: z.string(),
    semver: z.string(),
    visibility: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "deployment_id": "deploymentId",
      "package_id": "packageId",
    });
  }),
);

export function packageVersionFromJSON(
  jsonString: string,
): SafeParseResult<PackageVersion, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PackageVersion$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PackageVersion' from JSON`,
  );
}
